import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { MariaDBTableDataset } from 'app/model/dataset/maria-db.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MariaDBTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class MariaDBTableDatasetAdapter extends TabularTypeDatasetAdapter<MariaDBTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: MariaDBTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(MariaDBTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: MariaDBTableDataset): Promise<MariaDBTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, MariaDBTableDataset.MODEL);
    }
}
